import { EDITOR_TOOLS, ProductTypes } from '@editor/config/constants'
import { EditorTool } from '@editor/interfaces/editor'
import { InspectionItemType } from '@editor/interfaces/inspection'
import { UserInfo } from '@editor/interfaces/interfaces'
import { ShapeKeyType } from '@editor/interfaces/shape'

import useEditor from './hooks/useEditor'
import useElementsPanel from './hooks/useElementsPanel'
import useMainCanvas from './hooks/useMainCanvas'

const DepthEstimation: EditorTool = {
  key: EDITOR_TOOLS.DEPTH,
  authCheck: (userProfile: UserInfo | null, isAllowedToModify: boolean) =>
    (userProfile?.owned_products.includes(ProductTypes.Hatsuly) && isAllowedToModify) || false,
  hooks: {
    useEditor,
    useMainCanvas,
    useElementsPanel,
  },
  config: {
    volume: {
      required: true,
      selectable: true,
      onlyOneSelectable: true,
    },
    cylinder: {
      required: true,
    },
    selectableShapes: [ShapeKeyType.CYLINDER],
    selectableInspectionItems: [InspectionItemType.Volume],
    dependencies: [EDITOR_TOOLS.VOLUME_POLYGON, EDITOR_TOOLS.CYLINDER, EDITOR_TOOLS.GRID],
  },
}

export default DepthEstimation
